
interface Translation {
    en: string;
    ar?: string;
}



export const getLang= (value: Translation, langValue: string): string  => { 
    var lang = langValue;
    var result = value.en;
    switch (lang) {
        case "en":
            result = value.en;
            break;
        case "ar":
            // result = value.en;
            result = value.ar ? value.ar : value.en;
            break;
        default:
            result = value.en;
            break;
    }
    return result;
}